import { render, staticRenderFns } from "./TreasurehuntQuestionForm.vue?vue&type=template&id=6b018c36&scoped=true&"
import script from "./TreasurehuntQuestionForm.vue?vue&type=script&lang=js&"
export * from "./TreasurehuntQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./TreasurehuntQuestionForm.vue?vue&type=style&index=0&id=6b018c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b018c36",
  null
  
)

export default component.exports